import { useEffect } from 'react';

import { Submit } from 'libs/form/Submit';
import { useFormContext } from 'libs/form/useFormContext';
import { useTranslation } from 'libs/i18n';
import { Button, Stack } from 'libs/ui';

import { useToggleEditable } from '../../hooks/useToggleEditable';

import { EmptyStyled, FormFooterStyled } from './OrderFormFooter.styles';

export interface OrderFormFooterProps {
  submitLoading?: boolean;
}

export const OrderFormFooter = ({ submitLoading }: OrderFormFooterProps) => {
  const { t } = useTranslation();

  const { readOnly, dirty, submitDisabled, resetForm } = useFormContext();

  const { disableEditable } = useToggleEditable();

  useEffect(() => {
    resetForm();
  }, [readOnly, resetForm]);

  if (readOnly) {
    return <EmptyStyled />;
  }

  return (
    <FormFooterStyled>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="flex-end"
        spacing={40}
        spacingMobile={24}
      >
        <Button
          label={t('common.cancel')}
          mode="text"
          onClick={disableEditable}
        />

        <Submit
          disabled={submitDisabled || !dirty}
          label={t('common.save')}
          loading={submitLoading}
        />
      </Stack>
    </FormFooterStyled>
  );
};
